import { apiClient } from "./client";

// ---------- Types ----------

export interface CodeChangelog {
  content: string;
}

export interface ConfigChangelogUser {
  id: number;
  full_name: string;
  email: string;
}

export interface ConfigChangelogItem {
  id: number;
  action: string;
  action_label: string;
  entity_type: string;
  entity_type_label: string;
  entity_id: number;
  entity_name: string;
  entity_link: string | null;
  description: string | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  created_at: string;
  user: ConfigChangelogUser | null;
}

export interface ConfigChangelogResponse {
  items: ConfigChangelogItem[];
  total_items: number;
  total_pages: number;
  current_page: number;
  page_size: number;
}

export interface ConfigChangelogParams {
  page?: number;
  page_size?: number;
  entity_type?: string;
  action?: string;
  user_id?: number;
  date_from?: string;
  date_to?: string;
}

// ---------- API calls ----------

export async function getCodeChangelog(): Promise<CodeChangelog> {
  const response = await apiClient.get<CodeChangelog>("/changelog/code");
  return response.data;
}

export async function getConfigChangelog(
  params: ConfigChangelogParams = {}
): Promise<ConfigChangelogResponse> {
  const response = await apiClient.get<ConfigChangelogResponse>(
    "/changelog/config",
    { params }
  );
  return response.data;
}
